<template>
  <div class="screeningResults">
    <div class="contentBox">
      <el-table :data="listData.list" border>
        <el-table-column prop="user_name" label="评价人"> </el-table-column>
        <el-table-column prop="score" label="评价总分"> </el-table-column>
        <el-table-column prop="status" :label="`${listData.type == 1 ? '筛选' : '面试'}结果`">
          <template slot-scope="scope">
            <div @click="lookData(scope.row)" :class="{link:scope.row.status}">
              {{ setText(scope.row.status) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="时间"> 
           <template slot-scope="scope">
            <div v-if="scope.row.status != 0" >
              {{ scope.row.update_time }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="result flex-center">
        最终结果： {{ listData.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {}
  },
  data() {
    return {
      tableHead: [
        {
          text: "评价人",
          props: "user_name",
        },
        {
          text: "评价总分",
          props: "score",
        },
        {
          text: "筛选结果",
          props: "status",
        },
        {
          text: "时间",
          props: "update_time",
        },
      ],
      tableData: [],
    };
  },
  methods: {
    lookData(row) {
      if (row.status) {
        this.$router.push('/addAssessment?type='+this.listData.type+'&eva_id=' + row.id)
      }
    },
    setText(status) {
      let typeText
      this.listData.type == 1 ? typeText = '面试' : typeText = '录用'
      return status == 0 ? '未填写' : status == 1 ? '推荐' + typeText : '不推荐' + typeText
    }
  }
};
</script>

<style lang="scss" scoped>
.screeningResults {
  padding: 10px;
  box-sizing: border-box;

  .result {
    border: 1px solid #8A8A8A;
    margin-top: 20px;
    height: 60px;
    font-weight: 700;
    font-size: 16px;
  }

  .link {
    color: #3399ff;
  }
}
</style>